import p1  from '../assets/id_1.png';
import p2  from '../assets/id_2.png';
import p3  from '../assets/id_3.png';
import p4 from '../assets/id_4.png';
import p5 from '../assets/id_5.png';
import p6 from '../assets/id_6.png';
import p7 from '../assets/id_7.png';
import p8 from '../assets/id_8.png';
import p9 from '../assets/id_9.png';
import p10 from '../assets/id_10.png';
import p11 from '../assets/id_11.png';
import p12 from '../assets/id_12.png';
import p13 from '../assets/id_13.png';
import p14 from '../assets/id_14.png';

const products = [
  {
    id: 1,
    name: 'Fortified NP',
    cat: 'npk',
    image: p1,
    // emoji: p1,
    colorBg: 'linear-gradient(135deg,#e8f8ee,#c5ecd4)',
    badge: 'Cost Effective',
    // price: '₹480',
    // unit: 'kg',
    rating: 4.9,
    reviews: 1284,
    desc: 'Balanced NP fertilizer that promotes fast and uniform crop growth. Improves root strength, nutrient absorption, chlorophyll content, and enhances flowering, fruiting, yield, and quality.',
    how: [
      'Apply via foliar spray or drip irrigation.',
      'Use as per crop requirement.',
      'Suitable for all crops including vegetables, fruits, and cereals.',
    ],
    specs: {
      Type: 'Fortified NP',
      Benefit: 'Growth + Yield + Stress tolerance',
      Form: 'Liquid/Suspension',
    },
    glance: ['🌿 All Crops', '💧 Fertigable', '📦 5–50 kg packs', '🏅 ISO Certified'],
  },
  {
    id: 2,
    name: 'NPK 11:11:08 + TE',
    cat: 'organic',
    // emoji: '🌱',
    image: p2,
    colorBg: 'linear-gradient(135deg,#faf7f0,#e8f8ee)',
    badge: 'Balanced Nutrition',
    price: '₹320',
    unit: 'kg',
    rating: 4.8,
    reviews: 982,
    desc: 'Fortified NPK fertilizer enriched with Zinc and Boron. Supports balanced growth, improves root development, enhances flowering and fruiting, and reduces nutrient deficiency symptoms.',
    how: [
      'Foliar spray: 2–3 ml per litre of water.',
      'Fertigation: 1–2 litre per acre.',
    ],
    specs: {
      N: '11%',
      P: '11%',
      K: '08%',
      TE: 'Zinc + Boron',
    },
    glance: ['♻️ 100% Organic', '🐛 Pest Deterrent', '🌍 Eco-Certified', '🤲 Hand-Blended'],
  },
  {
    id: 3,
    name: 'NPK 08:08:08 + TE (Flowfert)',
    cat: 'micro',
    // emoji: '💧',
    image: p3,
    colorBg: 'linear-gradient(135deg,#e6f1fb,#b5d4f4)',
    badge: 'Multi Crop',
    price: '₹640',
    unit: 'kg',
    rating: 4.7,
    reviews: 621,
    desc: 'Liquid balanced fertilizer for fast nutrient availability. Promotes lush green foliage, strong growth, and higher yield across multiple crops.',
    how: [
      'Fertigation: 2–5 litre per acre.',
      'Foliar spray: 2–3 ml per litre.',
      'Sugarcane special: 10 ml per litre.',
      'Repeat every 15–20 days.',
    ],
    specs: {
      N: '08%',
      P: '08%',
      K: '08%',
      Form: 'Liquid',
      Crops: 'All crops',
    },
    glance: ['🔬 Chelated Form', '🌡 Stress Tolerant', '💊 Deficiency Fix', '🌾 Boosts Quality'],
  },
  {
    id: 4,
    name: 'NPK 06:00:18 + TE',
    cat: 'organic',
    // emoji: '🍃',
    image: p4,
    colorBg: 'linear-gradient(135deg,#eaf3de,#c0dd97)',
    badge: 'High Efficiency',
    price: '₹195',
    unit: 'kg',
    rating: 4.8,
    reviews: 1543,
    desc: 'Promotes uniform and vigorous crop growth. Improves root development, flowering, fruiting, chlorophyll formation, stress tolerance, and overall yield quality.',
    how: [
      'Apply via foliar spray or drip.',
      'Use regularly for better results.',
    ],
    specs: {
      N: '06%',
      P: '00%',
      K: '18%',
      Type: 'High Potassium',
    },
    glance: ['🦠 Anti-Nematode', '🌿 N-Rich', '🧪 800ppm Neem', '🌾 Seed Safe'],
  },
  {
    id: 5,
    name: 'Grow CaB (Calcium + Boron)',
    cat: 'micro',
    // emoji: '🍅',
    image: p5,
    colorBg: 'linear-gradient(135deg,#faeeda,#fac775)',
    badge: 'Fruit Quality',
    price: '₹390',
    unit: 'kg',
    rating: 4.6,
    reviews: 487,
  desc: 'Combination of Calcium (11%) and Boron (3%) that strengthens cell walls, improves root growth, reduces blossom end rot, prevents fruit cracking, and enhances shelf life.',
    how: [
      'Use 2.5 ml per litre of water.',
    ],
    specs: {
      Ca: '11%',
      B: '3%',
      Use: 'Fruit crops, vegetables',
    },
    glance: ['🌳 Fruit Sizing', '💪 Strong Stems', '🌡 Drought Resistant', '🍌 Fruit Crops'],
  },
  {
    id: 6,
    name: 'Gluco Max (Zn + Fe + B)',
    cat: 'micro',
    // emoji: '🔬',
    image: p6,
    colorBg: 'linear-gradient(135deg,#fbeaf0,#f4c0d1)',
    badge: 'Micronutrient Boost',
    price: '₹525',
    unit: 'kg',
    rating: 4.7,
    reviews: 334,
    desc: 'Blend of Zinc, Iron, and Boron that improves chlorophyll formation, reduces yellowing (chlorosis), enhances flowering, fruiting, and increases crop productivity.',
    how: [
      'Use 2.5 ml per litre of water.',
    ],
    specs: {
      Zn: '5%',
      Fe: '2.5%',
      B: '0.5%',
    },
    glance: ['🌿 Root Health', '🍄 Mycorrhizae', '⚡ Fast Establish', '🌱 Nursery Safe'],
  },
  {
    id: 7,
    name: 'Grow Zinc Oxide 39.5%',
    cat: 'micro',
    // emoji: '🌾',
    image: p7,
    colorBg: 'linear-gradient(135deg,#faeeda,#fac775)',
    badge: 'High Zinc',
    price: '₹445',
    unit: 'kg',
    rating: 4.5,
    reviews: 289,
    desc: 'High concentration Zinc fertilizer that ensures long-lasting availability. Improves plant growth hormones, reduces yellowing, enhances photosynthesis and increases yield.',
    how: [
      'Use 1.5 ml per litre of water.',
    ],
    specs: {
      Zn: '39.5%',
      Form: 'Suspension',
    },
    glance: ['🌱 Germination Boost', '🌾 Kharif Ready', '🔬 High Phosphorus', '💧 Irrigation Safe'],
  },
  {
    id: 8,
    name: 'Grow Zinc EDTA 12%',
    cat: 'micro',
    // emoji: '⚡',
    image: p8,
    colorBg: 'linear-gradient(135deg,#faece7,#f0997b)',
    badge: 'Fast Absorption',
    price: '₹580',
    unit: 'kg',
    rating: 4.6,
    reviews: 412,
    desc: 'Chelated Zinc fertilizer for quick absorption. Promotes hormone production, new leaf growth, reduces chlorosis, and improves flowering and yield.',
    how: [
      'Use 1 g per litre of water.',
    ],
    specs: {
      Zn: '12%',
      Form: 'EDTA Chelated',
    },
    glance: ['🍅 Anti-BER', '🫑 Fruit Quality', '💊 Chelated', '🌾 Veg Crops'],
  },
  {
    id: 9,
    name: 'Grow Sil (Orthosilicic Acid 2%)',
    cat: 'specialty',
    // emoji: '🛡',
    image: p9,
    colorBg: 'linear-gradient(135deg,#e8f8ee,#5fc283)',
    badge: 'Stress Protector',
    price: '₹720',
    unit: 'kg',
    rating: 4.9,
    reviews: 876,
    desc: 'Improves root strength, enhances disease resistance, reduces drought and heat stress, strengthens plant structure, and boosts overall yield and quality.',
    how: [
      'Use 2 ml per litre of water.',
    ],
    specs: {
      Si: '2%',
      Type: 'Orthosilicic Acid',
    },
    glance: ['🎋 Sugarcane Expert', '📈 Brix Boost', '💪 Cane Girth', '🏆 Farmer Favourite'],
  },
  {
    id: 10,
    name: 'Grow Boron 20%',
    cat: 'micro',
    // emoji: '🌸',
    image: p10,
    colorBg: 'linear-gradient(135deg,#EEEDFE,#AFA9EC)',
    badge: 'Flower Booster',
    price: '₹950',
    unit: 'kg',
    rating: 4.8,
    reviews: 234,
    desc: 'High purity Boron fertilizer that improves pollination, reduces flower drop, enhances fruit set, and improves sweetness, size, and quality.',
    how: [
      'Use 2 g per litre of water.',
    ],
    specs: {
      B: '20%',
    },
    glance: ['🍇 Berry Size', '🎨 Colour Boost', '⭐ Export Grade', '🍷 Nashik Proven'],
  },
  {
    id: 11,
    name: 'Grow Sizer',
    cat: 'specialty',
    // emoji: '🍇',
    image: p11,
    colorBg: 'linear-gradient(135deg,#c5ecd4,#1D9E75)',
    badge: 'Fruit Enlarger',
    price: '₹380',
    unit: 'kg',
    rating: 4.7,
    reviews: 543,
    desc: 'Contains Zinc, Boron, and Potassium Gluconate for faster nutrient absorption. Enhances fruit size, weight, sweetness, and improves stress tolerance and plant health.',
    how: [
      'Use 2 ml per litre of water.',
    ],
    specs: {
      Zn: '3%',
      B: '0.5%',
      K: '12.5%',
    },
    glance: ['🌊 Flood Safe', '🛡 Blast Resistant', '🐛 Lodging Prevention', '🌾 High Tillering'],
  },
  {
    id: 12,
    name: 'GI P-BOOST (Seaweed Extract)',
    cat: 'organic',
    // emoji: '🌊',
    image: p12,
    colorBg: 'linear-gradient(135deg,#E1F5EE,#1D9E75)',
    badge: 'Seaweed Power',
    price: '₹280',
    unit: 'litre',
    rating: 4.6,
    reviews: 710,
    desc: 'Premium seaweed extract (Ascophyllum nodosum) with 22% active compounds. Enhances plant growth, improves stress tolerance, and boosts yield and crop quality naturally.',
  how: [
    'Foliar Spray: 2–3 ml per litre of water.',
    'Spray at regular intervals.',
    'Soil / Drip: 3–5 ml per litre during key growth stages.',
    'Suitable for all crops.',
  ],
  specs: {
    Type: 'Seaweed Extract',
    Active: '22%',
    Source: 'Ascophyllum nodosum',
    Form: 'Liquid',
    Crop: 'All crops',
  },
  glance: ['🌱 Root Boost', '🌼 Flowering', '🛡 Stress Control', '🌾 Yield Increase'],
},
{
  id: 13,
  name: 'GI Grow Gold',
  cat: 'organic',
  // emoji: '🌿',
  image: p13,
  colorBg: 'linear-gradient(135deg,#eefbea,#9be15d)',
  badge: 'Premium Mix',
  price: 520,
  unit: 'ml',
  rating: 4.9,
  reviews: 278,
  desc: 'Advanced plant nutrition formula made with seaweed extract, humic & fulvic acid, amino acids, and vitamins. Improves soil health, nutrient uptake, and overall crop productivity.',
  how: [
    'Foliar Spray: 2–3 ml per litre of water.',
    'Apply at regular intervals.',
    'Soil / Drip: 3–5 ml per litre during growth stages.',
  ],
  specs: {
    Content: 'Seaweed + Humic + Fulvic + Amino + Vitamins',
    Form: 'Liquid',
    Crop: 'All crops',
    Benefit: 'Growth + Soil Health',
  },
  glance: ['🌱 Root Development', '🍇 Fruit Set', '💧 Soil Health', '⚡ Growth Boost'],
},

{
  id: 14,
  name: 'GROWBION',
  cat: 'organic',
  // emoji: '🧬',
  image: p14,
  colorBg: 'linear-gradient(135deg,#e6f4fb,#90cfe8)',
  badge: 'Natural Origin',
  price: 550,
  unit: 'ml',
  rating: 4.8,
  reviews: 876,
  desc: 'Premium quality product formulated from proteins of natural origin. Promotes healthy growth, improves yield, and enhances quality across a wide range of crops.',
  how: [
    'Foliar Spray: 2–3 ml per litre of water. Spray at regular intervals.',
    'Soil Application / Drip: 3–5 ml per litre of water.',
    'Apply during critical growth stages for best results.',
    'Safe, eco-friendly and suitable for all crops.',
  ],
  specs: {
    Type: 'Natural Protein Liquid',
    Base: 'Proteins of Natural Origin',
    Volume: '500 ml',
    Form: 'Liquid',
    Certification: 'ISO 9001:2015',
    Crop: 'All Crops',
    Use: 'Growth + Yield + Immunity',
  },
  glance: ['🧬 Natural Protein', '🛡 Plant Immunity', '🌿 All Crops', '♻️ Eco Friendly'],
}
];

export default products;
